import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const LinearIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M12.5709 13.3124C12.6997 13.201 12.8254 13.0842 12.9477 12.9619C15.6841 10.2254 15.6841 5.78877 12.9477 3.05233C10.2112 0.31589 5.77458 0.31589 3.03814 3.05233C2.91583 3.17463 2.799 3.30033 2.68763 3.42912L12.5709 13.3124Z"
		></path>
		<path
			fill="currentColor"
			d="M11.7362 13.9323L2.06768 4.26378C1.87376 4.5701 1.70591 4.88818 1.56414 5.21485L10.7851 14.4359C11.1118 14.2941 11.4299 14.1262 11.7362 13.9323Z"
		></path>
		<path
			fill="currentColor"
			d="M9.69907 14.8044L1.1956 6.30093C1.09212 6.71487 1.02692 7.13642 1 7.55994L8.44006 15C8.86359 14.9731 9.28513 14.9079 9.69907 14.8044Z"
		></path>
		<path
			fill="currentColor"
			d="M6.91705 14.9316L1.06841 9.08296C1.28783 10.5028 1.94441 11.8681 3.03814 12.9619C4.13187 14.0556 5.49721 14.7122 6.91705 14.9316Z"
		></path>
	</svg>
))
